<template>
	<div class="role">
		<div class="right-wrap">
			<div class="query-wrap">
				<div class="query-item">
					<el-button :class="queryBtnVal == 'used' ? 'query-item-used active' : 'query-item-used'" @click="handleUsed('used')">使用次数</el-button>
					<el-button :class="queryBtnVal == 'times' ?'query-item-times active' : 'query-item-times'" @click="handleUsed('times')">剩余次数</el-button>
					<!-- <div class="query-date">
						<div class="query-date-label">套餐开通日期</div>
						<el-date-picker
						  v-model="dateValue"
						  type="daterange"
						  value-format="timestamp"
						  range-separator="~"
						  start-placeholder="开始日期"
						  end-placeholder="结束日期"
						  @change="searchDateChange">
						</el-date-picker>
					</div> -->
				</div>
				<!-- <el-button class="query-btn" @click="getReport">查询</el-button> -->
			</div>
			<el-table
				:data="tableData"
				style="width: 100%"
				@selection-change="handleSelectionChange"
				row-key="id"
				:tree-props="{children: 'children', hasChildren: 'hasChildren'}"
				class="list" >
				<template slot="empty">
					<div class="empty-wrap">
						<el-image class="empty-img" :src="require('@/assets/images/empty-download.png')"></el-image>
						<div class="empty-text">暂无数据</div>
					</div>
				</template>
				<!-- :height="mainHeight - 180 + 'px'" -->
				<el-table-column class='selection-cell' type="selection" width="55"></el-table-column>
				<!-- <el-table-column
				      type="selection"
				      width="55">
					<el-table-column
						prop="created_at"
						label="健康100"
						align="center"
						class-name="created_at"
					>	
						<template slot="header" slot-scope="{ column,$index }">
							<div class="item-top">
								<p class="gray-txt">使用次数</p>
								<p class="gray-txt">剩余次数</p>
							</div>
						</template>
					</el-table-column>
				</el-table-column> -->
				<el-table-column
					prop="id"
					label="编号"
					width="90"
					align="center"
					class-name="id"
				>	
					
				</el-table-column>
				<el-table-column
					prop="created_at"
					label="企业名称"
					align="center"
					class-name="created_at"
				>	
					<!-- <template slot="header" slot-scope="{ column,$index }">
						
					</template> -->
					<template slot-scope="scope">
						<div class="flex">
							<div class="">{{scope.row.name}}</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="created_at"
					label="健康100"
					align="center"
					class-name="created_at"
				>
					<template slot-scope="scope">
						<div class="" v-for="item in scope.row.goodsList" :key="item.goods_id">
							<div class="" v-if="item.goods_id == 1">
								<div class="" v-if="scope.row.pay_mode == 1 && queryBtnVal == 'times'">{{item.times ? item.times : 0}}</div>
								<div class="" v-if="scope.row.pay_mode == 1 && queryBtnVal == 'used'">{{item.used ? item.used : 0}}</div>
								<div class="" v-if="scope.row.pay_mode == 2">{{item.used ? item.used : 0}}</div>
							</div>
							<!-- <div class="" >--</div> -->
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="created_at"
					label="自由定制"
					align="center"
					class-name="created_at"
				>
					<el-table-column
						prop="created_at"
						label="M20基础套餐"
						align="center"
						class-name="created_at"
					>
						<template slot-scope="scope">
							<div class="" v-for="item in scope.row.goodsList" :key="item.goods_id">
								<div class="" v-if="item.goods_id == 2">
									<div class="" v-if="scope.row.pay_mode == 1 && queryBtnVal == 'times'">{{item.custom.hasOwnProperty('base') ? (item.custom.base.hasOwnProperty('times') ? item.custom.base.times : 0) : 0}}</div>
									<div class="" v-if="scope.row.pay_mode == 1 && queryBtnVal == 'used'">{{item.custom.hasOwnProperty('base') ? (item.custom.base.hasOwnProperty('used') ? item.custom.base.used : 0) : 0}}</div>
									<div class="" v-if="scope.row.pay_mode == 2">{{item.custom.hasOwnProperty('base') ? (item.custom.base.hasOwnProperty('used') ? item.custom.base.used : 0) : 0}}</div>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="created_at"
						label="通用健康评分"
						align="center"
						class-name="created_at"
					>
						<template slot-scope="scope">
							<div class="" v-for="item in scope.row.goodsList" :key="item.goods_id">
								<div class="" v-if="item.goods_id == 2">
									<div class="" v-if="scope.row.pay_mode == 1 && queryBtnVal == 'times'">{{item.custom.hasOwnProperty('mlev') ? (item.custom.mlev.hasOwnProperty('times') ? item.custom.mlev.times : 0) : 0}}</div>
									<div class="" v-if="scope.row.pay_mode == 1 && queryBtnVal == 'used'">{{item.custom.hasOwnProperty('mlev') ? (item.custom.mlev.hasOwnProperty('used') ? item.custom.mlev.used : 0) : 0}}</div>
									<div class="" v-if="scope.row.pay_mode == 2">{{item.custom.hasOwnProperty('mlev') ? (item.custom.mlev.hasOwnProperty('used') ? item.custom.mlev.used : 0) : 0}}</div>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="created_at"
						label="A1同族群PLM对比"
						align="center"
						class-name="created_at"
					>
						<template slot-scope="scope">
							<div class="" v-for="item in scope.row.goodsList" :key="item.goods_id">
								<div class="" v-if="item.goods_id == 2">
									<div class="" v-if="scope.row.pay_mode == 1 && queryBtnVal == 'times'">{{item.custom.hasOwnProperty('packageA') ? (item.custom.packageA.hasOwnProperty('times') ? item.custom.packageA.times : 0) : 0}}</div>
									<div class="" v-if="scope.row.pay_mode == 1 && queryBtnVal == 'used'">{{item.custom.hasOwnProperty('packageA') ? (item.custom.packageA.hasOwnProperty('used') ? item.custom.packageA.used : 0) : 0}}</div>
									<div class="" v-if="scope.row.pay_mode == 2">{{item.custom.hasOwnProperty('packageA') ? (item.custom.packageA.hasOwnProperty('used') ? item.custom.packageA.used : 0) : 0}}</div>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="created_at"
						label="B1共病风险"
						align="center"
						class-name="created_at"
					>
						<template slot-scope="scope">
							<div class="" v-for="item in scope.row.goodsList" :key="item.goods_id">
								<div class="" v-if="item.goods_id == 2">
									<div class="" v-if="scope.row.pay_mode == 1 && queryBtnVal == 'times'">{{item.custom.hasOwnProperty('packageB') ? (item.custom.packageB.hasOwnProperty('times') ? item.custom.packageB.times : 0) : 0}}</div>
									<div class="" v-if="scope.row.pay_mode == 1 && queryBtnVal == 'used'">{{item.custom.hasOwnProperty('packageB') ? (item.custom.packageB.hasOwnProperty('used') ? item.custom.packageB.used : 0) : 0}}</div>
									<div class="" v-if="scope.row.pay_mode == 2">{{item.custom.hasOwnProperty('packageB') ? (item.custom.packageB.hasOwnProperty('used') ? item.custom.packageB.used : 0) : 0}}</div>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="created_at"
						label="C1疾病风险远期预测"
						align="center"
						class-name="created_at"
					>
						<template slot-scope="scope">
							<div class="" v-for="item in scope.row.goodsList" :key="item.goods_id">
								<div class="" v-if="item.goods_id == 2">
									<div class="" v-if="scope.row.pay_mode == 1 && queryBtnVal == 'times'">{{item.custom.hasOwnProperty('packageC') ? (item.custom.packageC.hasOwnProperty('times') ? item.custom.packageC.times : 0) : 0}}</div>
									<div class="" v-if="scope.row.pay_mode == 1 && queryBtnVal == 'used'">{{item.custom.hasOwnProperty('packageC') ? (item.custom.packageC.hasOwnProperty('used') ? item.custom.packageC.used : 0) : 0}}</div>
									<div class="" v-if="scope.row.pay_mode == 2">{{item.custom.hasOwnProperty('packageC') ? (item.custom.packageC.hasOwnProperty('used') ? item.custom.packageC.used : 0) : 0}}</div>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="created_at"
						label="D1健康促进方案"
						align="center"
						class-name="created_at"
					>
						<template slot-scope="scope">
							<div class="" v-for="item in scope.row.goodsList" :key="item.goods_id">
								<div class="" v-if="item.goods_id == 2">
									<div class="" v-if="scope.row.pay_mode == 1 && queryBtnVal == 'times'">{{item.custom.hasOwnProperty('packageD') ? (item.custom.packageD.hasOwnProperty('times') ? item.custom.packageD.times : 0) : 0}}</div>
									<div class="" v-if="scope.row.pay_mode == 1 && queryBtnVal == 'used'">{{item.custom.hasOwnProperty('packageD') ? (item.custom.packageD.hasOwnProperty('used') ? item.custom.packageD.used : 0) : 0}}</div>
									<div class="" v-if="scope.row.pay_mode == 2">{{item.custom.hasOwnProperty('packageD') ? (item.custom.packageD.hasOwnProperty('used') ? item.custom.packageD.used : 0) : 0}}</div>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="created_at"
						label="QBTB骨折预测"
						align="center"
						class-name="created_at"
					>
						<template slot-scope="scope">
							<div class="" v-for="item in scope.row.goodsList" :key="item.goods_id">
								<div class="" v-if="item.goods_id == 2">
									<div class="" v-if="scope.row.pay_mode == 1 && queryBtnVal == 'times'">{{item.custom.hasOwnProperty('packageFB') ? (item.custom.packageFB.hasOwnProperty('times') ? item.custom.packageFB.times : 0) : 0}}</div>
									<div class="" v-if="scope.row.pay_mode == 1 && queryBtnVal == 'used'">{{item.custom.hasOwnProperty('packageFB') ? (item.custom.packageFB.hasOwnProperty('used') ? item.custom.packageFB.used : 0) : 0}}</div>
									<div class="" v-if="scope.row.pay_mode == 2">{{item.custom.hasOwnProperty('packageFB') ? (item.custom.packageFB.hasOwnProperty('used') ? item.custom.packageFB.used : 0) : 0}}</div>
								</div>
							</div>
						</template>
					</el-table-column>
				</el-table-column>
				<el-table-column
					prop="mobile"
					label="GBP馨享母婴"
					align="center"
					class-name="mobile"
				>
					<template slot-scope="scope">
						<div class="" v-for="item in scope.row.goodsList" :key="item.goods_id">
							<div class="" v-if="item.goods_id == 3">
								<div class="" v-if="scope.row.pay_mode == 1 && queryBtnVal == 'times'">{{item.times ? item.times : 0}}</div>
								<div class="" v-if="scope.row.pay_mode == 1 && queryBtnVal == 'used'">{{item.used ? item.used : 0}}</div>
								<div class="" v-if="scope.row.pay_mode == 2">{{item.used ? item.used : 0}}</div>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="mobile"
					label="AI健康"
					align="center"
					class-name="mobile"
				>
					<template slot-scope="scope">
						<div class="" v-for="item in scope.row.goodsList" :key="item.goods_id">
							<div class="" v-if="item.goods_id == 5">
								<div class="" v-if="scope.row.pay_mode == 1 && queryBtnVal == 'times'">{{item.times ? item.times : 0}}</div>
								<div class="" v-if="scope.row.pay_mode == 1 && queryBtnVal == 'used'">{{item.used ? item.used : 0}}</div>
								<div class="" v-if="scope.row.pay_mode == 2">{{item.used ? item.used : 0}}</div>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="mobile"
					label="AI银发骨健康套餐"
					align="center"
					class-name="mobile"
				>
					<template slot-scope="scope">
						<div class="" v-for="item in scope.row.goodsList" :key="item.goods_id">
							<div class="" v-if="item.goods_id == 6">
								<div class="" v-if="scope.row.pay_mode == 1 && queryBtnVal == 'times'">{{item.times ? item.times : 0}}</div>
								<div class="" v-if="scope.row.pay_mode == 1 && queryBtnVal == 'used'">{{item.used ? item.used : 0}}</div>
								<div class="" v-if="scope.row.pay_mode == 2">{{item.used ? item.used : 0}}</div>
							</div>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="down-cell">
				<el-button class="down-btn" @click="handleDown">下载</el-button>
			</div>
			<!-- <div class="contrast" v-if="tableData.length > 0">
				对比
			</div> -->
			<!-- 分页 -->
			<!-- <div class="foot-pagination" >
				<el-pagination v-if="pageCount > 10" class="pagination qjc-texta-c" hide-on-single-page @current-change="handleCurrentChange" layout="prev, pager, next" :page-size="10" :total="pageCount"></el-pagination>
			</div> -->
			<!-- <el-pagination
				class="pagination qjc-texta-c"
				layout="prev, pager, next"
				hide-on-single-page
				:current-page.sync="pager.page"
				:page-count="pager.pagecount"
				:page-size="pager.pagesize"
				:total="pager.count"
				@current-change="pageChange">
			</el-pagination> -->
		</div>
		
		
	</div>
</template>

<script>
	import { getStatistics } from "@/utils/axios.js"
	
	export default{
		name: 'mainStatistics',
		data () {
			return {
				dateValue: '',
				tableData: [],
				pageCount: 0,
				checked: true,
				mainHeight: (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) - 60,
				queryBtnVal: 'used',
				selectList: [],
			}
		},
		mounted() {
			this.handleLoad()
		},
		methods:{
			handleLoad() {
				getStatistics({act:"",startat: this.dateValue ? this.dateValue[0] / 1000 : '', endat:  this.dateValue ? this.dateValue[1] / 1000 + 86399 : ''}).then((res) => {
					if(res.code == 200) {
						this.tableData = res.data
					}
				})
			},
			getReport() {
				this.handleLoad()
			},
			searchDateChange(val) {
				// this.handleLoad()
			},
			handleSelectionChange(val) {
				let list = [];
				if (val && val.length > 0) {
					// 处理选中列表为选中Id列表
					val.map((item, index) => {
						list.push(item.id);
					});
				}
				this.selectList = list; //选中Id列表
			},
			handleCurrentChange() {
				
			},
			handleUsed(val) {
				this.queryBtnVal = val
			},
			handleDown() {
				
			},
		}
	}
</script>

<style scoped>
	.right-wrap >>> .el-table th {
		background-color: #F2F4FA;
	}
	
	.right-wrap >>> .el-date-editor.el-input, .el-date-editor.el-input__inner {
		width: 380px;
	}
	
	.right-wrap >>> .el-date-editor .el-range-separator {
		color: #DBDDE6;
	}
	.right-wrap >>> .el-table th>.cell {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #293033;
		padding: 0 8px;
	}
	.right-wrap >>> .el-table td, .right-wrap >>> .el-table th.is-leaf {
		border-color: #CED4F0;
	}
	.right-wrap >>> .el-table--border th, .right-wrap >>> .el-table__fixed-right-patch {
		border-color: #CED4F0;
	}
	.right-wrap >>> .el-table--border td, .right-wrap >>> .el-table--border th, .right-wrap >>> .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
		border-color: #CED4F0;
	}
</style>
<style lang="scss" scoped>
	.role{
		display: flex;
		// padding: 24px;
		width: 100%;
		height: 100%;
		// border: 12px solid #F2F4FA;
		
		.time-header {
			position: relative;
			height: 54px;
			.times-used {
				position: absolute;
				top: 0;
				left: 0;
			}
			.tiems-line {
				position: absolute;
				top: 26px;
				left: 36px;
				width: 36px;
				height: 1px;
				transform: rotate(-45deg);
				background-color: #CED4F0;
			}
			.times-surplus {
				position: absolute;
				top: 30px;
				right: 0;
			}
		}
		
		.right-wrap {
			flex: 1;
			width: 100%;
			padding: 28px 24px;
			.query-wrap {
				display: flex;
				align-items: center;
				// justify-content: space-between;
				margin-bottom: 16px;
				
				.query-package {
					width: 226px;
				}
			}
			
			.c-danger{
				color: #FF4C52;
			}
			
			.query-date {
				display: flex;
				align-items: center;
				margin-right: 40px;
				
				.query-date-label {
					margin-right: 10px;
					font-size: 14px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #525866;
				}
			}
			
			.query-btn {
				width: 96px;
				height: 34px;
				background: #6883FB;
				border-radius: 17px;
				font-size: 14px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #FFFFFF;
				border: none;
			}
			
		}
		
		.right-wrap .flex{
			display: flex;
			align-items: center;
		}
		
		.pagination{
			text-align: center;
		}
		
		.foot-pagination {
			// position: fixed;
			// bottom: 0;
			display: flex;
			align-items: center;
			justify-content: center;
			min-width: 1160px;
			height: 80px;
			background-color: #fff;
			z-index: 9;
		}
		
		.nextBtn {
			position: fixed;
			left: 280px;
			bottom: 24px;
			display: block;
			cursor: pointer;
			width: 96px;
			height: 34px;
			height: 34px;
			background: #6883FB;
			border-radius: 17px;
			border: none;
			color: white;
			outline: none;
			font-size: 14px;
		}
		
	}
	.contrast {
		position: relative;
		width: 96px;
		height: 34px;
		text-align: center;
		line-height: 34px;
		border-radius: 17px;
		font-size: 14px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
		background: #6883FB;
		z-index: 99;
		margin-left: 40px;
		cursor: pointer;
	}
	
	.query-item {
		display: flex;
		align-items: center;
	}
	
	.query-item-used {
		width: 86px;
		height: 34px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #525866;
		border-radius: 4px;
		background-color: #fff;
		border: 1px solid #DBDDE6;
	}
	.query-item-times {
		width: 86px;
		height: 34px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #525866;
		border-radius: 4px;
		background-color: #fff;
		border: 1px solid #DBDDE6;
		margin-right: 0.4rem;
	}
	.query-item  .active{
		color: #FFFFFF;
		border: none;
		background-color: #6883FB;
	}
	.down-cell {
		padding-bottom: 20px;
	}
	.down-btn {
		width: 86px;
		height: 34px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #fff;
		border-radius: 4px;
		background-color: #6883FB;
		border: none;
		margin-top: 0.2rem;
	}
	
	.empty-wrap {
		padding: 100px 0;
	}
	
	.empty-img {
		width: 222px;
		height: 206px;
	}
</style>